import React from "react";
import { ALIGN, InfoBox, INFOBOX_TYPE } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { useScreenSize } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";

const DeliveryBanner = () => {
  const screenSize = useScreenSize();

  return (
    <InfoBox
      contentAlign={screenSize === "L" ? ALIGN.CENTER : undefined}
      testID="delivery-banner"
      text={useI18nMessage({ domain: DOMAIN, id: I18nMessages.CHECKOUT_DELIVERY_BANNER })}
      type={INFOBOX_TYPE.SQUARED}
    />
  );
};

export { DeliveryBanner };
